import { render, staticRenderFns } from "./shopPlatFormResult.vue?vue&type=template&id=2e6570ef&scoped=true"
import script from "./shopPlatFormResult.vue?vue&type=script&lang=js"
export * from "./shopPlatFormResult.vue?vue&type=script&lang=js"
import style0 from "./shopPlatFormResult.vue?vue&type=style&index=0&id=2e6570ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6570ef",
  null
  
)

export default component.exports